export class RedeemOrder{
    GlobalOrderId: string;
    UserId: number;
    OrganizationId: number;
    UrlDomain: string;
}
